import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { compose } from 'react-recompose';
import { SimpleLoadingComponent } from '../../utils/apollo';
import RepVisitsRatings from './repvisits-ratings';
import optInorOutRatings from './opt-in-or-out-ratings-mutation';

const query = gql`
  query RepVisitsRatings {
    viewer {
      id
      heAccount {
        id
        repVisitsSettings {
          optedOutOfRepVisitsRatings
        }
      }
    }
  }
`;

const graphqlData = compose(
  graphql(query),
  graphql(optInorOutRatings, { name: 'optInorOutRatings' }),
);

export default SimpleLoadingComponent(graphqlData)(RepVisitsRatings);
